import { Alert, ALERT_VARIANTS } from '@features/modal-invitation/ui/alert';
import type { MessagesStats } from '@pages/event/api/useFetchMessagesStats';
import clsx from 'clsx';
import { FC } from 'react';
import { formatFullName, getUnsentChannelView } from '../../lib/unsent-channel';
import type { UnsentErrorChannel } from '../../lib/types';
import styles from './unsent-content.module.scss';

interface UnsentContentProps {
  channel: UnsentErrorChannel;
  messagesStats: MessagesStats;
}

export const UnsentContent: FC<UnsentContentProps> = ({ channel, messagesStats }) => {
  const { columnLabel, alertText, errorData, getContact } = getUnsentChannelView(channel, messagesStats);

  return (
    <div className={styles.unsentContent}>
      <div className={styles.unsentSection}>
        <Alert variant={ALERT_VARIANTS.WARNING}>{alertText}</Alert>
        <div className={styles.unsentSectionBlock}>
          <div className={styles.unsentTableHeader}>
            <div className={clsx(styles.unsentTableHeaderCell, styles.unsentTableColumnName)}>{columnLabel}</div>
            <div className={clsx(styles.unsentTableHeaderCell, styles.unsentTableColumnReason)}>Причина</div>
          </div>
        </div>
      </div>

      <div className={styles.unsentScroll}>
        {errorData.map((item, index) => (
          <div key={`${channel}-${index}`} className={styles.unsentTableRow}>
            <div className={styles.unsentTableRowCellName}>
              <span className={styles.unsentTableRowName}>{formatFullName(item)}</span>
              <span className={styles.unsentTableRowContact}>{getContact(item)}</span>
            </div>
            <p className={styles.unsentTableRowCellReason}>{item.errorText}</p>
          </div>
        ))}
      </div>
    </div>
  );
};
